import { Typography } from "@mui/material";

const EstadosNteLabel = () => {
  return (
    <>
      <div style={{ display: "flex", padding: 5, marginTop: 10 }}>
        <Typography>
          <span style={{ color: "blue" }}>NTE Recibido por la ART</span> cuando la{" "}
          <span style={{ color: "green" }}>
            importación de nóminas es correcta
          </span>
        </Typography>
      </div>
    </>
  );
};

export default EstadosNteLabel;
